import ValueGeneratorInterface from "./ValueGeneratorInterface"
import ValueInterface from "../../Model/Value/ValueInterface"
import RandomNumberGenerator from "../RandomNumberGenerator"

export default class ExpressionValueGenerator implements ValueGeneratorInterface {
  constructor(
    private readonly randomNumberGenerator: RandomNumberGenerator,
    private readonly expressionValueGenerators: ValueGeneratorInterface[],
  ) {}
  public supports(_: number, level: number): boolean {
    return level > 2
  }

  public generate(value: number, level: number): ValueInterface {
    const generator: ValueGeneratorInterface =
      this.randomNumberGenerator.pick<ValueGeneratorInterface>(
        this.expressionValueGenerators.filter(
          (generator: ValueGeneratorInterface): boolean =>
            generator.supports(level, value),
        ),
      )

    return generator.generate(value, level)
  }
}
